import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wholeToFixed',
})
export class WholeToFixedPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    if (typeof value === 'number') {
      if (Number.isSafeInteger(value)) return `${parseInt(String(value))}.00`;
      else return String(value);
    } else return 'NaN';
  }
}
